import * as React from 'react';
import { Camera, type ICameraMenuListProps } from './Cameras.types';

export class CameraMenuList extends React.Component<ICameraMenuListProps> {
    constructor(props: ICameraMenuListProps) {
        super(props);
    }

    public renderItem(camera: Camera, index: number): JSX.Element {
        let endUrl: string;
        if (this.props.currentArea) {
            endUrl = '?currentArea=' + encodeURIComponent(this.props.currentArea);
        } else if (this.props.currentRoad) {
            endUrl = '?currentRoad=' + encodeURIComponent(this.props.currentRoad);
        }

        let carretClassName = '';
        if (camera.isCurrent) {
            carretClassName = 'icon-sort-down icon-rotate-270';
        }

        return (
            <li key={index} className={'side-navigation-subsubmenu__item' + (camera.isCurrent ? ' side-navigation-subsubmenu__item--active' : '')}>
                <a href={camera.url + endUrl} className="side-navigation-subsubmenu__link">
                    <span
                        className={carretClassName}
                        title={carretClassName === 'icon-sort-down icon-rotate-270' ? 'Markör stängd' : 'Markör öppen'}
                    ></span>
                    <span>{camera.name}</span>
                </a>
            </li>
        );
    }

    public render(): JSX.Element {
        return (
            <ul className="side-navigation-subsubmenu__list">
                {this.props.cameras.sort((x, y) => x.sortIndex - y.sortIndex).map(this.renderItem.bind(this))}
            </ul>
        );
    }
}
